import { CustomerSchema } from "@redotech/redo-model/customer";
import { z } from "zod";

export const getOrCreateCustomerFromPhoneNumber = {
  input: z.object({ number: z.string() }),
  output: CustomerSchema,
};
